if (!customElements.get('policy-hub-accordion')) {
    class PolicyHubAccordion extends HTMLElement {
        constructor() {
            super();
            this.mobileMedia = window.matchMedia('(max-width: 999px)');
            this.handleMediaChange = this.handleMediaChange.bind(this);
            this.handleTriggerClick = this.handleTriggerClick.bind(this);
            this.handlePanelTransitionEnd = this.handlePanelTransitionEnd.bind(this);
        }

        connectedCallback() {
            this.items = Array.from(this.querySelectorAll('.policy-hub__item'));

            if (this.mobileMedia.addEventListener) {
                this.mobileMedia.addEventListener('change', this.handleMediaChange);
            } else {
                this.mobileMedia.addListener(this.handleMediaChange);
            }

            this.items.forEach((item) => {
                const trigger = item.querySelector('.policy-hub__trigger');
                const panel = item.querySelector('.policy-hub__panel');

                if (trigger) {
                    trigger.addEventListener('click', this.handleTriggerClick);
                }

                if (panel) {
                    panel.addEventListener('transitionend', this.handlePanelTransitionEnd);
                }
            });

            this.syncState(true);
        }

        disconnectedCallback() {
            if (this.mobileMedia.removeEventListener) {
                this.mobileMedia.removeEventListener('change', this.handleMediaChange);
            } else {
                this.mobileMedia.removeListener(this.handleMediaChange);
            }

            this.items.forEach((item) => {
                const trigger = item.querySelector('.policy-hub__trigger');
                const panel = item.querySelector('.policy-hub__panel');

                if (trigger) {
                    trigger.removeEventListener('click', this.handleTriggerClick);
                }

                if (panel) {
                    panel.removeEventListener('transitionend', this.handlePanelTransitionEnd);
                }
            });
        }

        handleMediaChange() {
            this.syncState(true);
        }

        handleTriggerClick(event) {
            if (!this.mobileMedia.matches) return;

            const trigger = event.currentTarget;
            const item = trigger.closest('.policy-hub__item');

            if (!item) return;

            this.toggleItem(item);
        }

        handlePanelTransitionEnd(event) {
            const panel = event.currentTarget;
            const item = panel.closest('.policy-hub__item');

            if (!panel || !item || event.propertyName !== 'height') return;

            if (item.classList.contains('is-open')) {
                panel.style.height = 'auto';
            }
        }

        syncState(skipAnimation = false) {
            if (!this.items || !this.items.length) return;

            if (this.mobileMedia.matches) {
                this.items.forEach((item) => {
                    const panel = item.querySelector('.policy-hub__panel');
                    const trigger = item.querySelector('.policy-hub__trigger');
                    const isOpen = item.classList.contains('is-open');

                    if (!panel || !trigger) return;

                    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
                    panel.hidden = false;

                    if (skipAnimation) {
                        panel.style.transition = 'none';
                    }

                    if (isOpen) {
                        panel.style.height = 'auto';
                    } else {
                        panel.style.height = '0px';
                    }

                    if (skipAnimation) {
                        requestAnimationFrame(() => {
                            panel.style.transition = '';
                        });
                    }
                });
            } else {
                this.items.forEach((item) => {
                    const panel = item.querySelector('.policy-hub__panel');
                    const trigger = item.querySelector('.policy-hub__trigger');

                    if (!panel || !trigger) return;

                    trigger.setAttribute(
                        'aria-expanded',
                        item.classList.contains('is-open') ? 'true' : 'false'
                    );

                    panel.hidden = true;
                    panel.style.height = '';
                });
            }
        }

        toggleItem(currentItem) {
            this.items.forEach((item) => {
                const panel = item.querySelector('.policy-hub__panel');
                const trigger = item.querySelector('.policy-hub__trigger');

                if (!panel || !trigger) return;

                const shouldOpen = item === currentItem ? !item.classList.contains('is-open') : false;

                if (shouldOpen) {
                    this.openItem(item, panel, trigger);
                } else {
                    this.closeItem(item, panel, trigger);
                }
            });
        }

        openItem(item, panel, trigger) {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            panel.hidden = false;

            panel.style.height = '0px';
            panel.offsetHeight;
            panel.style.height = `${panel.scrollHeight}px`;
        }

        closeItem(item, panel, trigger) {
            item.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            panel.hidden = false;

            if (panel.style.height === 'auto' || !panel.style.height) {
                panel.style.height = `${panel.scrollHeight}px`;
            }

            panel.offsetHeight;
            panel.style.height = '0px';
        }
    }

    customElements.define('policy-hub-accordion', PolicyHubAccordion);
}